document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-qs-copy]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var value = el.getAttribute('data-qs-copy');

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).catch(function () {});
      }

      var tag = el.querySelector('.qs-copied-tag');
      if (!tag) {
        tag = document.createElement('span');
        tag.className = 'qs-copied-tag';
        tag.textContent = 'Copied!';
        el.appendChild(tag);
      }
      tag.classList.add('is-visible');
      clearTimeout(el._qsCopyTimeout);
      el._qsCopyTimeout = setTimeout(function () {
        tag.classList.remove('is-visible');
      }, 1200);
    });
  });
});
